import { IconButton, InputText } from '@dixa/lib-shared-habla';

import styles from '../../searchControls.module.scss';

type FilterSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  'data-testid'?: string;
};

export const FilterSearchInput = ({
  value,
  onChange,
  placeholder,
  'data-testid': dataTestId,
}: FilterSearchInputProps): JSX.Element => (
  <div className={styles.searchInputWrapper} data-testid={dataTestId}>
    <InputText
      type="search"
      autoFocus
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      suffix={
        value
          ? {
              type: 'custom',
              noWrap: true,
              value: (
                <IconButton
                  variant="tertiary"
                  icon="close"
                  onClick={() => onChange('')}
                />
              ),
            }
          : undefined
      }
    />
  </div>
);
